import { formatPrice } from "../utils/formatPrice";

const Cart = ({
  cartProducts = [],
  cartTotal = 0,
  onAddToCart,
  onDecreaseCartItem,
  onRemoveCartItem,
  onOpenDetails,
  onToggleWishlist,
  wishlistItems = {},
}) => {
  return (
    <main className="page-shell product-page" aria-label="Cart page">
      <section className="cart-page">
        <div className="section-container">
          <div className="section-heading split cart-page-heading">
            <div>
              <p>Shopping bag</p>
              <h2>Your Cart</h2>
              <span>
                Review items, update quantities, and proceed to checkout.
              </span>
            </div>

            <a className="text-link" href="#/shop">
              Continue shopping
            </a>
          </div>

          {cartProducts.length > 0 ? (
            <div className="cart-page-grid">
              <div className="cart-page-items" role="list">
                {cartProducts.map((product) => {
                  const isWishlisted = Boolean(wishlistItems?.[product.id]);
                  return (
                    <div key={product.id} className="cart-page-item" role="listitem">
                      <button
                        type="button"
                        className="cart-page-thumb"
                        onClick={() => onOpenDetails?.(product)}
                        aria-label={`Open ${product.name} details`}
                      >
                        <img src={product.image} alt={product.name} />
                      </button>

                      <div className="cart-page-meta">
                        <h3>{product.name}</h3>
                        <div className="cart-page-sub">
                          <span>{product.category}</span>
                          <span className="dot">•</span>
                          <span>{formatPrice(product.price)}</span>
                        </div>

                        <div className="cart-qty-controls cart-qty-controls--page">
                          <button
                            type="button"
                            aria-label={`Decrease ${product.name}`}
                            onClick={() => onDecreaseCartItem?.(product.id)}
                          >
                            -
                          </button>
                          <span>{product.quantity}</span>
                          <button
                            type="button"
                            aria-label={`Increase ${product.name}`}
                            onClick={() => onAddToCart?.(product)}
                          >
                            +
                          </button>
                          <button
                            type="button"
                            className="cart-remove-btn"
                            onClick={() => onRemoveCartItem?.(product.id)}
                          >
                            Remove
                          </button>
                        </div>

                        <button
                          type="button"
                          className={`wishlist-toggle ${isWishlisted ? "active" : ""}`}
                          aria-label={
                            isWishlisted
                              ? `Remove ${product.name} from wishlist`
                              : `Add ${product.name} to wishlist`
                          }
                          onClick={() => onToggleWishlist?.(product.id)}
                        >
                          {isWishlisted ? "Wishlisted" : "Add to wishlist"}
                        </button>
                      </div>

                      <strong className="cart-page-price">
                        {formatPrice(product.price * product.quantity)}
                      </strong>
                    </div>
                  );
                })}
              </div>

              <aside className="cart-page-summary" aria-label="Cart summary">
                <div className="cart-summary-card">
                  <h3>Billing Total</h3>
                  <div className="cart-summary-row">
                    <span>Total</span>
                    <strong>{formatPrice(cartTotal)}</strong>
                  </div>

                  <p className="cart-summary-note">
                    Checkout is available from the header cart popup.
                  </p>

                  <a className="primary-btn cart-checkout-cta" href="#/" onClick={(e)=>{e.preventDefault();
                    // keep simple: suggest using header popup
                    window.scrollTo(0,0);
                  }}>
                    Proceed to checkout
                  </a>
                </div>
              </aside>
            </div>
          ) : (
            <div className="cart-empty">
              <div className="cart-empty-card">
                <h2>Your cart is empty</h2>
                <p>
                  Add products from the shop and come back anytime.
                </p>
                <a className="primary-btn" href="#/shop">
                  Browse products
                </a>
              </div>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};

export default Cart;

